import { RastreioRepository } from "../repository/rastreio_repository";

export class RastreioService {
	constructor() {
		this.rastreioRepository = new RastreioRepository();
	}

	async getByCodigo(codigo) {
		return await this.rastreioRepository.getByCodigo(codigo);
	}
}
